import { getToken } from "src/utils/authUtils";


let BASE_URL = process.env.REACT_APP_API_URL

async function getCsrfToken() {
    const response = await fetch(`${BASE_URL}/csrf/token`, { method: "GET", credentials: "include" });
    const data = await response.json();
    return data.csrfToken;
  }
  

export async function fetchAllDataApi( options: RequestInit = {}): Promise<any> {

    const token = getToken();
    //const csrfToken = await getCsrfToken();
  
  
    const headers = {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      //  "X-CSRF-TOKEN": csrfToken,
    };
    try {
      const response = await fetch(`${BASE_URL}/risks/getAll`, {
        ...options,
        headers,
        // credentials: "include"
      });
  
      const data = await response.json();
  
      if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        //console.log("Failed to fetch");
      }
      return data;
    } catch (error: any) {
      //////console.log(error)
      //console.log(error);
    }
  }



  export async function fetchAllCategoryDataApi(): Promise<any> {
    try {
        const token = getToken();
        //const csrfToken = await getCsrfToken();
        const headers = {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            //  "X-CSRF-TOKEN": csrfToken,
        };
        const response = await fetch(`${BASE_URL}/categories/getAll`, {
            // credentials: "include" ,
            method: "GET",
            headers,
        });
  
        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            //console.log("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        //console.log(error);
    }
  }
  